<template>
  <div class="property_wrap">
    <div class="pro_top">{{property.label}}设置</div>
    <div class="pro_con">
      <el-form label-width="80px">
        <el-form-item label="组件标题:">
          <el-input v-model="property.label"></el-input>
        </el-form-item>
      </el-form>
      <div style="padding:15px;">
        <div class="cooperation-body">
          <draggable v-model="form.list" :options="{draggable:'.draggableItem',animation: 150}" :move="getdata"
                     @update="datadragEnd" class="draggable-body-list">
            <transition-group class="draggable-body">
              <div v-for="(item,index) in form.list" :key="index" class="draggableItem" :draggable="draggable"
                   :style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"
                   :class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">
                <i class="el-icon-circle-close" v-if="index!==0" @click="detelBody(index)"></i>
              </div>
            </transition-group>
          </draggable>
          <div class="el-icon-plus add-cooperation" @click="addCooperation">
          </div>
        </div>
        <!-- <el-upload
                class="addicon"
                :action="uploadTokenImgUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :data="data_">
          <img v-if="fileList" :src="fileList" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload> -->
        <div class="addicon">
          <div class="el-upload el-upload--text" @click="corppervisible = true">
            <img v-if="fileList" :src="fileList" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
        </div>         
        <p>点击上传图片</p>
        <p class="imgdesc-bottomline">最佳尺寸：210*90px</p>
        <p class="imgdesc-bottomline">建议上传白色背景横版商标图片</p>
      </div>
    </div>
    <corpper :visible.sync="corppervisible"
      v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>
  </div>
</template>
<script>
  import api from "@/api.js";
  import draggable from 'vuedraggable';
  import corpper from "@/components/dialog/corpper.vue";
  export default {
    props: ["property"],
    components: {
      draggable,corpper
    },
    data() {
      return {
        draggable: true,
        uploadTokenImgUrl: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        dialogVisible: false,
        fileList: '/static/img/addimg.jpg',
        form: {
          label: '',
          list: []
        },
        currentindex: 0,
        imgSize: 11,
        corppervisible: false
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    created() {
      document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if(this.property.list.length===0){
        this.form.list.push('https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png')
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      datadragEnd(evt) {
        this.currentindex = evt.newIndex
      },
      getdata(data) {
      },
      indexLine(index) {
        this.currentindex = index
        this.fileList = this.form.list[index]
      },
      addCooperation(){
        this.form.list.push('https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png')
      },
      detelBody(index){
        this.form.list.splice(index, 1)
      },
      imgAddBack(option) {
        this.fileList = option;
        this.form.list[this.currentindex] = option;
        this.$set(this.form.list,this.currentindex,option) //这样就能被vue监控到，更新视图
      }
    }
  };
</script>
